<template>
    <div class="table-container">
        <table class="table table-striped">
            <thead>
                <tr>
                    <th scope="col">Name</th>
                    <th scope="col">Modified At</th>
                    <th scope="col">Size</th>
                </tr>
            </thead>
            <tbody>
                <template v-if="!files.length">
                    <tr>
                        <td colspan="3">No files</td>
                    </tr>
                </template>
                <template v-else>
                    <tr v-for="file in files" :key="file.name">
                        <td>{{ file.name }}</td>
                        <td>{{ file.modified_at }}</td>
                        <td>{{ file.size }}</td>
                    </tr>
                </template>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: {
        companyId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            files: [],
        }
    },
    mounted() {
        this.$emit('start-loading');

        axios.get(route('rft.clients.files', { company: this.companyId }))
            .then(({ data }) => this.files = data)
            .finally(() => this.$emit('stop-loading'));
    },
}
</script>


<style scoped lang="scss">
.table-container {
    max-height: 400px;
    overflow: auto;
}
</style>
